import axios from 'axios'
import config from '../../config/index.js'

const HTTP = axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP.interceptors.request.use(function (config) {
  if (config) {
    config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt')
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

export default {
  /* GET */
  _get (_url) {
    return HTTP.get(_url)
  },
  /* PUT */
  putReferral (_url, _referralId, _labTestResult) {
    return HTTP.put(_url, {
      referralId: _referralId,
      labTestResult: _labTestResult
    })
  },
  /* POST */
  _post (_url) {
    return HTTP.post(_url, {})
  },
  postConsent (_url, _consent) {
    return HTTP.post(_url, {
      consent: _consent
    })
  },
  postTokenStart (_url, _ssn) {
    return HTTP.post(_url, {
      ssn: _ssn
    })
  },
  postTokenCheck (_url, _ssn, _code) {
    return HTTP.post(_url, {
      ssn: _ssn,
      code: _code
    })
  },
  postRegistration (_url, _registration) {
    return HTTP.post(_url, {
      socialSecurityNumber: _registration.socialSecurityNumber,
      isAnonymous: _registration.isAnonymous,
      reserveNumber: _registration.reserveNumber,
      phoneNumber: _registration.phoneNumber,
      languageCode: _registration.languageCode,
      verificationCode: _registration.verificationCode,
      sexWithoutCondom: _registration.sexCondom,
      sharingSyringe: _registration.shareNeedle,
      sexWithoutCondomAbroad: _registration.sexAbroad,
      currentlyLivingInMentionedRegions: _registration.regions,
      labId: _registration.labId
    })
  },
  postVerifyStart (_url, _phone) {
    return HTTP.post(_url, {
      phone: _phone
    })
  },
  postVerifyCheck (_url, _phone, _code) {
    return HTTP.post(_url, {
      phone: _phone,
      code: _code
    })
  },
  postReferral (_url, _languageCode, _labId) {
    return HTTP.post(_url, {
      languageCode: _languageCode,
      labId: _labId
    })
  },
  /* PATCH, DELETE, OPTIONS etc */
  patchInvites (_url, _invites, _invmsg) {
    return HTTP.patch(_url, {
      'invitation': {
        invites: _invites,
        invitationMessage: _invmsg
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js